"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icons = void 0;
var Icons;
(function (Icons) {
    Icons[Icons["Account"] = 0] = "Account";
    Icons[Icons["AgentBooking"] = 1] = "AgentBooking";
    Icons[Icons["Alert"] = 2] = "Alert";
    Icons[Icons["AlertOutline"] = 3] = "AlertOutline";
    Icons[Icons["AlertTriangle"] = 4] = "AlertTriangle";
    Icons[Icons["Application"] = 5] = "Application";
    Icons[Icons["ApplicationComplete"] = 6] = "ApplicationComplete";
    Icons[Icons["ArrowDown"] = 7] = "ArrowDown";
    Icons[Icons["ArrowDownright"] = 8] = "ArrowDownright";
    Icons[Icons["ArrowLeft"] = 9] = "ArrowLeft";
    Icons[Icons["ArrowRight"] = 10] = "ArrowRight";
    Icons[Icons["ArrowUp"] = 11] = "ArrowUp";
    Icons[Icons["Asterisk"] = 12] = "Asterisk";
    Icons[Icons["Attendees"] = 13] = "Attendees";
    Icons[Icons["Barcode"] = 14] = "Barcode";
    Icons[Icons["Booking"] = 15] = "Booking";
    Icons[Icons["Building"] = 16] = "Building";
    Icons[Icons["Bullet"] = 17] = "Bullet";
    Icons[Icons["Calendar"] = 18] = "Calendar";
    Icons[Icons["Camera"] = 19] = "Camera";
    Icons[Icons["Cancelled"] = 20] = "Cancelled";
    Icons[Icons["CaretDown"] = 21] = "CaretDown";
    Icons[Icons["CaretLeft"] = 22] = "CaretLeft";
    Icons[Icons["CaretRight"] = 23] = "CaretRight";
    Icons[Icons["CaretUp"] = 24] = "CaretUp";
    Icons[Icons["ChartGantt"] = 25] = "ChartGantt";
    Icons[Icons["ChartReport"] = 26] = "ChartReport";
    Icons[Icons["Checkbox"] = 27] = "Checkbox";
    Icons[Icons["CheckboxUnselected"] = 28] = "CheckboxUnselected";
    Icons[Icons["CheckIn"] = 29] = "CheckIn";
    Icons[Icons["CheckOut"] = 30] = "CheckOut";
    Icons[Icons["ChevronDown"] = 31] = "ChevronDown";
    Icons[Icons["ChevronDownSmall"] = 32] = "ChevronDownSmall";
    Icons[Icons["ChevronLeft"] = 33] = "ChevronLeft";
    Icons[Icons["ChevronLeftSmall"] = 34] = "ChevronLeftSmall";
    Icons[Icons["ChevronRight"] = 35] = "ChevronRight";
    Icons[Icons["ChevronRightSmall"] = 36] = "ChevronRightSmall";
    Icons[Icons["ChevronRightThin"] = 37] = "ChevronRightThin";
    Icons[Icons["ChevronUp"] = 38] = "ChevronUp";
    Icons[Icons["ChevronUpSmall"] = 39] = "ChevronUpSmall";
    Icons[Icons["ChevronUpThin"] = 40] = "ChevronUpThin";
    Icons[Icons["ClearFilters"] = 41] = "ClearFilters";
    Icons[Icons["Clock"] = 42] = "Clock";
    Icons[Icons["CloseCircle"] = 43] = "CloseCircle";
    Icons[Icons["CloseThick"] = 44] = "CloseThick";
    Icons[Icons["CloseThin"] = 45] = "CloseThin";
    Icons[Icons["Cog"] = 46] = "Cog";
    Icons[Icons["Column"] = 47] = "Column";
    Icons[Icons["Connect"] = 48] = "Connect";
    Icons[Icons["Designer"] = 49] = "Designer";
    Icons[Icons["Drag"] = 50] = "Drag";
    Icons[Icons["Edit"] = 51] = "Edit";
    Icons[Icons["EllipsesHorizontal"] = 52] = "EllipsesHorizontal";
    Icons[Icons["EllipsesVertical"] = 53] = "EllipsesVertical";
    Icons[Icons["Export"] = 54] = "Export";
    Icons[Icons["FieldTypeBoolean"] = 55] = "FieldTypeBoolean";
    Icons[Icons["FieldTypeDate"] = 56] = "FieldTypeDate";
    Icons[Icons["FieldTypeInt"] = 57] = "FieldTypeInt";
    Icons[Icons["FieldTypeKey"] = 58] = "FieldTypeKey";
    Icons[Icons["FieldTypeString"] = 59] = "FieldTypeString";
    Icons[Icons["File"] = 60] = "File";
    Icons[Icons["FilterActive"] = 61] = "FilterActive";
    Icons[Icons["Filters"] = 62] = "Filters";
    Icons[Icons["First"] = 63] = "First";
    Icons[Icons["Flag"] = 64] = "Flag";
    Icons[Icons["Folder"] = 65] = "Folder";
    Icons[Icons["FolderOpen"] = 66] = "FolderOpen";
    Icons[Icons["FolderOutline"] = 67] = "FolderOutline";
    Icons[Icons["FolderShared"] = 68] = "FolderShared";
    Icons[Icons["FolderStarred"] = 69] = "FolderStarred";
    Icons[Icons["Food"] = 70] = "Food";
    Icons[Icons["Function"] = 71] = "Function";
    Icons[Icons["Groups"] = 72] = "Groups";
    Icons[Icons["Headset"] = 73] = "Headset";
    Icons[Icons["Heart"] = 74] = "Heart";
    Icons[Icons["Help"] = 75] = "Help";
    Icons[Icons["Hide"] = 76] = "Hide";
    Icons[Icons["Home"] = 77] = "Home";
    Icons[Icons["ImagePlaceholder"] = 78] = "ImagePlaceholder";
    Icons[Icons["Import"] = 79] = "Import";
    Icons[Icons["Info"] = 80] = "Info";
    Icons[Icons["Inspection"] = 81] = "Inspection";
    Icons[Icons["Interaction"] = 82] = "Interaction";
    Icons[Icons["Invoicing"] = 83] = "Invoicing";
    Icons[Icons["Key"] = 84] = "Key";
    Icons[Icons["Last"] = 85] = "Last";
    Icons[Icons["Link"] = 86] = "Link";
    Icons[Icons["List"] = 87] = "List";
    Icons[Icons["Lock"] = 88] = "Lock";
    Icons[Icons["Mail"] = 89] = "Mail";
    Icons[Icons["MapMarker"] = 90] = "MapMarker";
    Icons[Icons["ModuleAdmin"] = 91] = "ModuleAdmin";
    Icons[Icons["ModuleCampusLife"] = 92] = "ModuleCampusLife";
    Icons[Icons["ModuleConduct"] = 93] = "ModuleConduct";
    Icons[Icons["ModuleConference"] = 94] = "ModuleConference";
    Icons[Icons["ModuleCustom"] = 95] = "ModuleCustom";
    Icons[Icons["ModuleDashboard"] = 96] = "ModuleDashboard";
    Icons[Icons["ModuleEntries"] = 97] = "ModuleEntries";
    Icons[Icons["ModuleFrontDesk"] = 98] = "ModuleFrontDesk";
    Icons[Icons["ModuleKeys"] = 99] = "ModuleKeys";
    Icons[Icons["ModuleMarketplace"] = 100] = "ModuleMarketplace";
    Icons[Icons["ModulePortal"] = 101] = "ModulePortal";
    Icons[Icons["ModuleReports"] = 102] = "ModuleReports";
    Icons[Icons["ModuleRoomInspections"] = 103] = "ModuleRoomInspections";
    Icons[Icons["ModuleRoomMatch"] = 104] = "ModuleRoomMatch";
    Icons[Icons["ModuleRooms"] = 105] = "ModuleRooms";
    Icons[Icons["ModuleTrustAccount"] = 106] = "ModuleTrustAccount";
    Icons[Icons["MouseHand"] = 107] = "MouseHand";
    Icons[Icons["MouseHandDrag"] = 108] = "MouseHandDrag";
    Icons[Icons["MousePointer"] = 109] = "MousePointer";
    Icons[Icons["Nav"] = 110] = "Nav";
    Icons[Icons["Note"] = 111] = "Note";
    Icons[Icons["NoteAdd"] = 112] = "NoteAdd";
    Icons[Icons["OpenLink"] = 113] = "OpenLink";
    Icons[Icons["Page"] = 114] = "Page";
    Icons[Icons["PageLandscape"] = 115] = "PageLandscape";
    Icons[Icons["PagePortrait"] = 116] = "PagePortrait";
    Icons[Icons["Paperclip"] = 117] = "Paperclip";
    Icons[Icons["Parameter"] = 118] = "Parameter";
    Icons[Icons["ParameterActive"] = 119] = "ParameterActive";
    Icons[Icons["Parcel"] = 120] = "Parcel";
    Icons[Icons["Paw"] = 121] = "Paw";
    Icons[Icons["Phone"] = 122] = "Phone";
    Icons[Icons["Picture"] = 123] = "Picture";
    Icons[Icons["Plus"] = 124] = "Plus";
    Icons[Icons["Portal"] = 125] = "Portal";
    Icons[Icons["Preview"] = 126] = "Preview";
    Icons[Icons["Print"] = 127] = "Print";
    Icons[Icons["Refresh"] = 128] = "Refresh";
    Icons[Icons["Report"] = 129] = "Report";
    Icons[Icons["Reposition"] = 130] = "Reposition";
    Icons[Icons["Resources"] = 131] = "Resources";
    Icons[Icons["Save"] = 132] = "Save";
    Icons[Icons["Search"] = 133] = "Search";
    Icons[Icons["SearchStop"] = 134] = "SearchStop";
    Icons[Icons["Share"] = 135] = "Share";
    Icons[Icons["ShieldNegative"] = 136] = "ShieldNegative";
    Icons[Icons["ShieldPositive"] = 137] = "ShieldPositive";
    Icons[Icons["Sort"] = 138] = "Sort";
    Icons[Icons["Source"] = 139] = "Source";
    Icons[Icons["SrIconFull"] = 140] = "SrIconFull";
    Icons[Icons["SrIconSimple"] = 141] = "SrIconSimple";
    Icons[Icons["Star"] = 142] = "Star";
    Icons[Icons["StarOutline"] = 143] = "StarOutline";
    Icons[Icons["SubReport"] = 144] = "SubReport";
    Icons[Icons["Tasks"] = 145] = "Tasks";
    Icons[Icons["TemporarySpace"] = 146] = "TemporarySpace";
    Icons[Icons["Tick"] = 147] = "Tick";
    Icons[Icons["TickCircle"] = 148] = "TickCircle";
    Icons[Icons["TickRounded"] = 149] = "TickRounded";
    Icons[Icons["Tool"] = 150] = "Tool";
    Icons[Icons["Trash"] = 151] = "Trash";
    Icons[Icons["User"] = 152] = "User";
    Icons[Icons["Users"] = 153] = "Users";
    Icons[Icons["Variable"] = 154] = "Variable";
    Icons[Icons["View"] = 155] = "View";
    Icons[Icons["Zoom"] = 156] = "Zoom";
})(Icons = exports.Icons || (exports.Icons = {}));
